export const referHospitalTranslations = {
    en: {
        // Page Title
        referralLetterFor: "Referral Letter for",
        allCampaigns: "All Campaigns",

        // Tab Labels
        hospitalRefer: "Hospital Refer",
        referredBeneficiary: "Referred Beneficiary",

        // Buttons
        sendReferralLetter: "Referral Letter",
        viewProfile: "View Profile",

        // Table Headers
        srNo: "Sr No",
        tokenNo: "Token No",
        campaignName: "Campaign Name",
        beneficiaryName: "Beneficiary Name",
        hospitalName: "Hospital Name",
        remark: "Remark",
        date: "Date",
        action: "Action",

        // Drawer Titles
        sendReferralLetterDrawer: "Send Referral Letter",
        viewReferralLetterDetails: "View Referral Letter Details",

        // Messages
        selectHospitalFirst: "Please select a hospital first",

        // Common
        notAvailable: "N/A",
        noValue: "--",

        // Module Name
        referredListModule: "Referral Letter List",
    },
    mr: {
        // Page Title
        referralLetterFor: "रेफरलसाठी पत्र",
        allCampaigns: "सर्व मोहिमा",

        // Tab Labels
        hospitalRefer: "रुग्णालय संदर्भित करा",
        referredBeneficiary: "संदर्भित लाभार्थी",

        // Buttons
        sendReferralLetter: "रेफरल पत्र",
        viewProfile: "प्रोफाइल पहा",

        // Table Headers
        srNo: "अ. क्र.",
        tokenNo: "टोकन क्रमांक",
        campaignName: "मोहिमेचे नाव",
        beneficiaryName: "लाभार्थीचे नाव",
        hospitalName: "रुग्णालयाचे नाव",
        remark: "शेरा",
        date: "तारीख",
        action: "क्रिया",

        // Drawer Titles
        sendReferralLetterDrawer: "रेफरल पत्र",
        viewReferralLetterDetails: "रेफरल पत्र तपशील पहा",

        // Messages
        selectHospitalFirst: "कृपया प्रथम रुग्णालय निवडा",

        // Common
        notAvailable: "उपलब्ध नाही",
        noValue: "--",

        // Module Name
        referredListModule: "रेफरल पत्र यादी",
    }
};
